(() => {
  const cardSelector = '.product-grid .grid__item, product-recommendations .grid__item';
  const purchaseSelector = [
    "[class*='samiQuickBuy']",
    "[class*='samitaWS_quickBuy']",
    'quantity-input',
    '.quantity',
    'quick-add-bulk',
    'product-form',
    "form[action*='/cart/add']",
    "[data-type='add-to-cart-form']",
    "button[name='add']",
  ].join(',');

  const hide = (element) => {
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
  };

  const protectCard = (card) => {
    card.querySelectorAll(purchaseSelector).forEach(hide);

    card.querySelectorAll('button, a').forEach((control) => {
      const label = control.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
      if (label === 'add to cart' || label === 'sold out') hide(control);
    });

    card.querySelectorAll("input[type='number']").forEach((input) => {
      const quantityControl = input.closest("quantity-input, .quantity, [class*='quantity'], [class*='qty']");
      hide(quantityControl || input);
    });
  };

  const protectGuestCards = (root = document) => {
    if (root.matches?.(cardSelector)) protectCard(root);
    root.querySelectorAll?.(cardSelector).forEach(protectCard);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
        if (!element) return;
        const card = element.closest?.(cardSelector);
        if (card) protectCard(card);
        if (node.nodeType === Node.ELEMENT_NODE) protectGuestCards(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', () => protectGuestCards());
})();
